// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"18":"product","166":"supportinfo","390":"swiper","406":"newsinfo","443":"about","551":"support","697":"news","823":"solution"}[chunkId] + "." + {"18":"d486d18c","166":"182ccff6","390":"315363ac","406":"a871ced1","443":"1e6356af","551":"997caada","697":"255d2e03","823":"cc802eb4"}[chunkId] + ".js";
};